// src/contexts/OpportunityModalContext.jsx
import React, { createContext, useContext, useState, useCallback } from 'react';
import { Dialog } from '@mui/material';
import OpportunityCard from '../components/cards/OpportunityCard';

const OpportunityModalContext = createContext(null);

export const useOpportunityModal = () => {
  const ctx = useContext(OpportunityModalContext);
  if (!ctx) return { openOpportunityModal: () => {} };
  return ctx;
};

export const OpportunityModalProvider = ({ children, onAddToLayout }) => {
  const [state, setState] = useState({ open: false, opportunity: null });

  const openOpportunityModal = useCallback((opportunity) => {
    setState({ open: true, opportunity });
  }, []);

  const closeOpportunityModal = useCallback(() => {
    setState(prev => ({ ...prev, open: false }));
  }, []);

  const handleAddToLayout = useCallback(() => {
    closeOpportunityModal();
    if (onAddToLayout && state.opportunity) onAddToLayout(state.opportunity);
  }, [state.opportunity, onAddToLayout, closeOpportunityModal]);

  return (
    <OpportunityModalContext.Provider value={{ openOpportunityModal }}>
      {children}
      <Dialog
        open={state.open}
        onClose={closeOpportunityModal}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { bgcolor: 'transparent', boxShadow: 'none', overflow: 'visible' } }}
      >
        {state.opportunity && (
          <OpportunityCard
            opportunity={state.opportunity}
            id={`modal_opp_${state.opportunity.opportunity_id || state.opportunity.name}`}
            onClose={closeOpportunityModal}
            disableDragging
            onAddToLayout={onAddToLayout ? handleAddToLayout : undefined}
          />
        )}
      </Dialog>
    </OpportunityModalContext.Provider>
  );
};
